export default {"src":"/_next/static/media/kycDocs.1eef1e8e.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};